// extracted by mini-css-extract-plugin
module.exports = {"geoJSONErrorsTitle":"GeoJSONErrorList_geoJSONErrorsTitle__1xiBb"};